import {useEffect} from 'react';
import {OnlyInLoginChecker} from '../../../../../../common/checkers/OnlyInLoginChecker';
import {ScheduledLastPageFetcher} from '../../../../../../common/fetchers/ScheduledLastPageFetcher';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {events} from '../constant/textViewerSagaEvents';

/**
 * 페이지 넘김 텍스트 뷰어의 진행도 저장/로드를 지원하기 위한 컨테이너입니다.
 */
export function PageTextViewerProgressContainer({
  seriesId,
  productId,
  isCmsPreview,
}: {
  seriesId: number;
  productId: number;
  isCmsPreview?: boolean;
}) {
  const {
    currentPage,
    currentPageCount,
    chapterCount,
    currentRate,
    currentChapterId,
    isContentLoaded,
    isPageCalculating,
    isDone,
  } = useTypedSelector(state => ({
    currentPage: state.textViewer.viewData[productId]?.currentPage,
    currentPageCount: state.textViewer.viewData[productId]?.currentPageCount,
    chapterCount: state.textViewer.viewData[productId]?.chapterCount,
    currentRate: state.textViewer.viewData[productId]?.currentRate,
    currentChapterId: state.textViewer.viewData[productId]?.currentChapterId,
    isContentLoaded: state.textViewer.viewData[productId]?.isContentLoaded,
    isPageCalculating: state.textViewer.viewData[productId]?.isPageCalculating,
    isDone: state.textViewer.viewData[productId]?.isDone,
  }));

  const dispatch = useTypedDispatch();

  useEffect(() => {
    if (!isContentLoaded && isPageCalculating) {
      return;
    }

    dispatch(events.updatePageViewerCurrentRateRequired({productId}));
  }, [
    currentPage,
    currentPageCount,
    currentChapterId,
    chapterCount,
    dispatch,
    isContentLoaded,
    productId,
    isPageCalculating,
  ]);

  if (isCmsPreview) {
    return null;
  }

  return (
    <OnlyInLoginChecker>
      {currentRate !== undefined &&
        currentChapterId !== undefined &&
        chapterCount !== undefined && (
          <ScheduledLastPageFetcher
            seriesId={seriesId}
            productId={productId}
            rate={currentRate}
            spineIndex={currentChapterId}
            isDone={!!isDone}
          />
        )}
    </OnlyInLoginChecker>
  );
}
